import { type Routes } from '@angular/router';
import { AuthWrapperComponent } from './auth.component';

export enum AuthRoutes {
  WELCOME = 'welcome',
  EMAIL = 'email',
  PHONE = 'phone',
}

export default [
  {
    path: '',
    component: AuthWrapperComponent,
    children: [
      {
        path: '',
        redirectTo: AuthRoutes.WELCOME,
        pathMatch: 'full',
      },
      {
        path: AuthRoutes.WELCOME,
        loadComponent: () => import('./welcome/welcome.component'),
        data: {
          hideBackButton: true,
        },
      },
      {
        path: AuthRoutes.EMAIL,
        loadChildren: () => import('./email/email.routes'),
      },
      {
        path: AuthRoutes.PHONE,
        loadChildren: () => import('./phone/phone.routes'),
      },
    ],
  },
  {
    path: '**',
    redirectTo: AuthRoutes.WELCOME,
    pathMatch: 'full',
  },
] satisfies Routes;
